import { render, staticRenderFns } from "./TablePopupDtableItem.vue?vue&type=template&id=33ab50e2&scoped=true"
import script from "./TablePopupDtableItem.vue?vue&type=script&lang=js"
export * from "./TablePopupDtableItem.vue?vue&type=script&lang=js"
import style0 from "./TablePopupDtableItem.vue?vue&type=style&index=0&id=33ab50e2&scoped=true&lang=css"
import style1 from "./TablePopupDtableItem.vue?vue&type=style&index=1&id=33ab50e2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ab50e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ab50e2')) {
      api.createRecord('33ab50e2', component.options)
    } else {
      api.reload('33ab50e2', component.options)
    }
    module.hot.accept("./TablePopupDtableItem.vue?vue&type=template&id=33ab50e2&scoped=true", function () {
      api.rerender('33ab50e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TablePopupDtableItem.vue"
export default component.exports